import PropTypes from "prop-types";
import { Button } from "react-bootstrap";

const ButtonOnly = ({
  buttonLabel,
  buttonIcon,
  buttonClick,
  variant = "info",
  size = "md",
  className = "",
  type = "button"
}) => {
  return (
    <Button
      type={type}
      onClick={buttonClick}
      variant={variant}
      size={size}
      className={`d-flex align-items-center gap-2 fw-semibold justify-content-center text-white ${className}`}
    >
      {buttonIcon && <span>{buttonIcon}</span>}
      <span>{buttonLabel}</span>
    </Button>
  );
};

ButtonOnly.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  buttonIcon: PropTypes.element,
  buttonClick: PropTypes.func.isRequired,
  variant: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
};

export default ButtonOnly;
